var _effectorFileName = "/src/shared/lib/startup/startup.ts";
import { withFactory as _withFactory } from "effector";
import { createEvent } from 'effector';
import { once } from 'patronum';
import { setup } from '../effector/router/model';
import { logger } from '../logger';

/**
 * This Event will be used to trigger the start of the app.
 */
export const appStarted = createEvent({
  loc: {
    file: _effectorFileName,
    line: 10,
    column: 26
  },
  name: "appStarted",
  sid: "-ht0c29"
});

/**
 * This event will be used to trigger the start of the app in browser. Mostly used to work with browser api.
 */
export const clientStarted = _withFactory({
  sid: "-eapxmr",
  fn: () => once(setup.map(() => {})),
  name: "clientStarted",
  method: "once",
  loc: {
    file: _effectorFileName,
    line: 15,
    column: 29
  }
});
appStarted.watch(() => logger.debug('App started'));
clientStarted.watch(() => logger.debug('App started in browser'));